import classnames from 'classnames';
import type { NotificationWrapperProps } from './notificationWrapper.types';

const NotificationWrapper = ({
  item,
  children,
  additionalClasses = '',
}: NotificationWrapperProps) => (
  <div
    className={classnames('notification', !item.isSeen ? '--new' : '', additionalClasses)}
    id={item.id}
  >
    {children}
  </div>
);

export default NotificationWrapper;
